import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { RegistroEvaluacion } from '@/app/models/interface/registro-evaluacion.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class RegistroEvaluacionService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'registro-evaluacion/';

  findAll(params: HttpParams) {
    const dir = this.url;
    return this.http
      .get<
        CustomResponse<PaginatorModel<RegistroEvaluacion[], HasPagination>>
      >(dir, { params })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }

  findOne(id: string) {
    const dir = this.url + id;
    return this.http.get<CustomResponse<RegistroEvaluacion>>(dir).pipe(
      catchError((err) => handleError(err)),
      map((data) => data.result),
    );
  }

  create(item: Partial<RegistroEvaluacion>) {
    return this.http
      .post<CustomResponse<RegistroEvaluacion>>(this.url, item)
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => data.result),
      );
  }
}
